export enum NursingOverviewType {
  MEDICATION_ADDED = 'MEDICATION_ADDED',
  MEDICATION_ENDED = 'MEDICATION_ENDED',
  NURSING_REPORT_ADDED = 'NURSING_REPORT_ADDED',
  CARE_PLAN_FORM_UPDATED = 'CARE_PLAN_FORM_UPDATED',
  WOUND_ADDED = 'WOUND_ADDED',
  WOUND_REPORT_ADDED = 'WOUND_REPORT_ADDED',
  PAIN_PROTOCOL_ADDED = 'PAIN_PROTOCOL_ADDED',
  PAIN_ASSESSMENT_ADDED = 'PAIN_ASSESSMENT_ADDED',
  FALL_PROTOCOL_ADDED = 'FALL_PROTOCOL_ADDED',
  VITAL_SIGN_WEIGHT = 'VITAL_SIGN_WEIGHT',
  VITAL_SIGN_WEIGHT_BMI = 'VITAL_SIGN_WEIGHT_BMI',
  VITAL_SIGN_WEIGHT_HISTORY = 'VITAL_SIGN_WEIGHT_HISTORY',
  VISIT_SHEET_UPDATED = 'VISIT_SHEET_UPDATED',
  VISIT_SHEET_QUESTION = 'VISIT_SHEET_QUESTION',
  NUTRITION_PROTOCOL = 'NUTRITION_PROTOCOL',
  SOCIAL_CARE_REPORT = 'SOCIAL_CARE_REPORT',
}
